export default "__VITE_ASSET__k2dC4PWA__"